export const Notifications = {
    stickersDidChange: "stickersDidChange",
    backgroundImageDidChange: "backgroundImageDidChange",
    userImageDidChange: "userImageDidChange",
    userUploadedPhoto: "userUploadedPhoto", // Posted specifically when user uploads a new photo
    colorDidChange: "colorDidChange", // object = { colorData: Object containing color selection info }
    colorBarWillOpen: "colorBarWillOpen",
    colorBarDidOpen: "colorBarDidOpen",
    colorBarWillClose: "colorBarWillClose",
    colorBarDidClose: "colorBarDidClose",
    surfacesBarWillOpen: "surfacesBarWillOpen",
    surfacesBarDidOpen: "surfacesBarDidOpen",
    surfacesBarWillClose: "surfacesBarWillClose",
    surfacesBarDidClose: "surfacesBarDidClose",
    walletPrintSurfaceDidChange: "walletPrintSurfaceDidChange",
    pricingDidChange: "pricingDidChange",
    previewCanvasDidShowUserImage: "previewCanvasDidShowUserImage", // object = { canvas: HTMLCanvasElement, canvasRect: DOMRect, contentBounds: Object, imageProxy: HTMLElement }
    previewCanvasDidRepositionUserImage: "previewCanvasDidRepositionUserImage", // object = { canvas: HTMLCanvasElement, canvasRect: DOMRect, contentBounds: Object, imageProxy: HTMLElement }
    previewCanvasDidFinishLoading: "previewCanvasDidFinishLoading",

    selectorDismissed: "selectorDismissed", // object = { sender: <OptionSelectorRound> ; event:  <Event> }
    currentDeviceChanged: "currentDeviceChanged", // only for debugging
    galleryPopoverWillShow: "galleryPopoverWillShow",
    galleryPopoverDidDismiss: "galleryPopoverDidDismiss",
    globalDocumentClick: "globalDocumentClick", // object = { event: MouseEvent, target: HTMLElement, timestamp: number }
    appWillBecomeActive: "appWillBecomeActive",
    appWillBecomeInactive: "appWillBecomeInactive"
};
